import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const reveal = { hidden: { opacity: 0, y: 40 }, show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 } }) };

export const SectionsBento = ({ pages, edition, lang }) => {
  const toc = pages.find((p) => p.template === "contents")?.toc || [];
  if (!toc.length) return null;
  const spans = ["col-span-2 row-span-2", "col-span-1 row-span-1", "col-span-1 row-span-1", "col-span-1 row-span-2", "col-span-1 row-span-1", "col-span-2 row-span-1", "col-span-1 row-span-1", "col-span-1 row-span-1", "col-span-2 row-span-1"];
  return (
    <section className="px-6 sm:px-12 py-24" data-testid="sections-bento">
      <div className="flex items-end justify-between gap-6 mb-10">
        <div>
          <div className="reader-label" style={{ opacity: 0.6 }}>{edition?.ui?.contents}</div>
          <h2 className="font-head font-semibold text-white mt-2" style={{ fontSize: "clamp(32px, 4vw, 56px)", lineHeight: 1 }}>{lang === "fr" ? "Dans cette édition" : "Inside this edition"}</h2>
        </div>
        <Link to={`/read/${lang}?p=3`} className="btn-silver" data-testid="bento-open-contents">{edition?.ui?.contents}</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" style={{ gridAutoRows: "minmax(180px, auto)" }}>
        {toc.map((t, i) => (
          <motion.div key={t.page} className={spans[i] || ""} variants={reveal} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}>
            <Link to={`/read/${lang}?p=${t.page}`} className="tile h-full min-h-[180px]" style={{ background: t.image ? "#111" : i % 2 ? "var(--bordeaux)" : "#232323", border: "1px solid rgba(217,218,221,0.1)" }} data-testid={`bento-tile-${t.page}`}>
              {t.image && <img src={t.image} alt={t.label} className="absolute inset-0 w-full h-full object-cover" style={{ opacity: 0.85, objectPosition: "50% 18%" }} />}
              {t.image && <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(25,25,25,0) 30%, rgba(25,25,25,0.85) 100%)" }} />}
              <div className="absolute inset-0 p-5 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <span className="reader-label" style={{ color: "var(--platinum)" }}>{String(t.page).padStart(2, "0")}</span>
                  <ArrowUpRight size={18} className="tile-arrow" />
                </div>
                <div>
                  <div className="font-head font-semibold text-white" style={{ fontSize: i === 0 ? 44 : 26, lineHeight: 0.95 }}>{t.label}</div>
                  <div className="font-head italic mt-1" style={{ fontSize: 15, opacity: 0.7 }}>{t.section}</div>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
